<template>
  <div class="flex column between" v-if="Object.keys($store.state.items).length > 0 && $store.state.show.eventsFull">
    <div class="">
      <div class="flex between align-center">
        <i class="update-text fa-2x fas fa-calendar r16"></i>
        <input class="flexw xs-font sm-input r16" type="text" v-model="searchEvents" placeholder="Find Event">
        <i class="fas fa-times" @click="$set($store.state.show, 'events', false); $set($store.state.show, 'eventsFull', false)"></i>
      </div>
    </div>
    <div>
      <b>Upcoming Events</b>
      <div 
        @click="$set($store.state.show, 'events', false); $set($store.state.show, 'eventsFull', false)" 
        :key="eventKey" 
        v-for="(events, eventKey) in $store.state.related.events">
          <code class="xs-font label b8">{{eventKey.toUpperCase()}}</code>
          <div 
            :key="eventItemKey" 
            v-for="(eventItem, eventItemKey) in events"
            class="sm-font p4" >
            <div v-if="(!searchEvents || JSON.stringify($store.state.items[eventKey][eventItemKey]).toLowerCase().indexOf(searchEvents.toLowerCase()) > -1) && $store.state.related.events[eventKey][eventItemKey] !== 'notgoing'">
              <router-link 
                :to="`/i/${eventKey}/${eventItemKey}`"
                class="flex between align-center wrap b8">
                <div class="flex wrap align-center" v-if="$store.state.items[eventKey] && $store.state.items[eventKey][eventItemKey]">
                  <img v-if="$store.state.items[eventKey][eventItemKey].basics.image" class="r8" :src="$store.state.items[eventKey][eventItemKey].basics.image" style="width: 40px; height: 40px; object-fit: cover" :alt="$store.state.items[eventKey][eventItemKey].basics.title">
                  <span>{{$store.state.items[eventKey][eventItemKey].basics.title}}</span>
                </div>
                <code v-if="$store.state.items[eventKey] && $store.state.items[eventKey][eventItemKey]"><i class="fas fa-calendar r8"></i>{{$store.state.items[eventKey][eventItemKey].events['start-date']}}</code>
              </router-link>
            </div>
          </div>
      </div>
    </div>
  </div>
  <div v-else>
    <code>Loading Events...</code>
  </div>
</template>

<script>

export default {
  name: 'events',
  data () {
    return {
      display: false,
      searchEvents: '',
      showEvents: false
    }
  },
  created () {
    this.$store.state.counts.cheating.eventCounts = this.$store.state.counts.cheating.eventCounts || {}
    this.$store.state.counts.cheating.eventCount = this.$store.state.counts.cheating.eventCount || {}
    Object.keys(this.$store.state.related.events).forEach((eventType) => {
      this.$store.state.counts.cheating.eventCounts[eventType] = Object.keys(this.$store.state.related.events[eventType]).length
      this.$store.state.counts.cheating.eventCount[eventType] = 0
      Object.keys(this.$store.state.related.events[eventType]).forEach((eventId) => {
        this.$store.state.counts.cheating.eventCount[eventType] = this.$store.state.counts.cheating.eventCount[eventType] + 1
        this.$store.dispatch('query', {
          type: 'item',
          collection: eventType,
          id: eventId
        }).then(() => {
          // this.key = Date.now()
          if (Object.keys(this.$store.state.related.events).length === Object.keys(this.$store.state.counts.cheating.eventCounts).length && JSON.stringify(this.$store.state.counts.cheating.eventCount) === JSON.stringify(this.$store.state.counts.cheating.eventCounts) && !this.$store.state.show.eventsFull) {
            setTimeout(() => {
              this.$store.commit('setState', {prop: 'show', prop2: 'eventsFull', val: true})
              this.$store.commit('setState', {prop: 'componentKeys', prop2: 'events', val: this.$store.state.componentKeys.events + 1})
            }, 250 + (this.$store.state.componentKeys.events + 1))
          }
        })
      })
    })
  }
}
</script>

<style>
  .event {
    flex-direction: column;
    display: flex;
    justify-content: flex-start;
    text-align: left;
    align-items: flex-start;
    background: rgba(0,0,0, 0.6);
    padding: 16px;
  }
  .event-title {
    text-align: center;
    width: 100%;
  }
  .event-title h1 {
    font-size: 3em;

  }
  .event-meta {
    display: flex;
    justify-content: space-between;
    width:100%;
  }
  .event-date {
    text-align: left;
  }
  .event-location {
    text-align: right;
  }
  .event-fold {
    width: 100%;
    display: flex;
    min-height: 270px;
    flex-wrap: wrap;
  }
  .event-cost {
    font-size: 1.4em
  }
  .big-money {
    font-size: 2em;
  }
  .event-img {
    width: 100%;
    min-height: 280px;
    height: auto;
    object-fit: cover;
    flex: 1 1 50%;
  }
  .event-order {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    padding: 0 16px;
    min-height:260px;
    flex: 1 1 40%;
    background: rgba(0,0,0,.8);
  }
  .event-order input {
    flex: 1 1;
  }
  .event-order button {
    flex: 1 1 auto;
  }
  .event-order-div {
    display: flex;
    width: 100%;
  }
  .event-content {
    width: 100%;
    
  }
</style>
